import { DependenciesInjection } from "app/di/DependencyInjection";
import { IAppFeedbackRepository } from "../domain/repositories/IAppFeedbackRepository";
import { AppFeedbackUseCase } from "../domain/useCases/AppFeedbackUseCase";
import { AppFeedbackToken } from "./AppFeedbackToken";
import { AppFeedbackImpl } from "../data/AppFeedbackImpl";
import { AppFeedbackViewModel } from "../presentation/viewModel/AppFeedbackViewModel";

export class AppFeedbackInjection {
  static initInjection() {
    DependenciesInjection.register<IAppFeedbackRepository>(
      AppFeedbackToken.IAppFeedbackRepository,
      AppFeedbackImpl,
      "otherRepo",
    );
    DependenciesInjection.register<AppFeedbackUseCase>(
      AppFeedbackToken.AppFeedbackUseCase,
      AppFeedbackUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<AppFeedbackViewModel>(
      AppFeedbackToken.AppFeedbackViewModel,
      AppFeedbackViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IAppFeedbackRepository>(
      AppFeedbackToken.IAppFeedbackRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<AppFeedbackUseCase>(
      AppFeedbackToken.AppFeedbackUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<AppFeedbackViewModel>(
      AppFeedbackToken.AppFeedbackViewModel,
    );
  }
}
